var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgDiamondLtr = function SvgDiamondLtr(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 100,
    height: 100,
    fill: "currentColor"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M68.112 11H29.624a2.27 2.27 0 0 0-1.71.776l-17.357 19.87a2.254 2.254 0 0 0-.146 2.781l36.74 52.201q.073.117.159.225l.834 1.185a2.272 2.272 0 0 0 3.712 0L89.59 34.427a2.254 2.254 0 0 0-.24-2.883l-19.621-19.87A2.27 2.27 0 0 0 68.112 11M56.028 74.24l27.03-38.405H71.464zm10.55-38.405H34.176l15.772 41.379zm16.182-4.52H71.354l-8.322-15.797h4.13zM42.957 15.518H57.91l8.322 15.797H34.635zm.998 58.7-14.63-38.384H16.94zm-6.12-58.7-8.321 15.797H16.858l13.799-15.797z",
    clipRule: "evenodd"
  })));
};
export default SvgDiamondLtr;